<template>
  <v-card outlined>
    <v-card-title> {{ label }}: {{ party.name }} (Individual)</v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="party.name"
            label="Name"
            :rules="[validateRequired]"
            @change="updateName"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            label="Address"
            :value="party.address"
            :rules="[validateRequired]"
            @change="updateAddress"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { validateRequired } from '@/utils/validationRules'

export default {
  name: 'SingleUserParty',
  props: {
    party: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {}
  },
  methods: {
    validateRequired,
    updateName: function (name) {
      this.party.name = name
      this.party.signatories[0].name = name
      this.update()
    },
    updateAddress(address) {
      this.party.address = address
      this.update()
    },
    update() {
      this.$emit('update', this.party)
    }
  }
}
</script>
